import { Box } from '@mui/material';
import TermsComponent from './TermsComponent';

export default function Terms() {
  return (
    <Box mt={['2.75rem', '2.75rem', '5.5625rem']}>
      <TermsComponent />
    </Box>
  );
}

